<template>
  <v-form ref="roleForm">
    <v-text-field
      v-model="data.nomb"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>
    <v-autocomplete
      v-model="data.dpto"
      :rules="rules.dpto"
      label="Departamento"
      :items="modulos"
      outlined
      dense
      required
    >
    </v-autocomplete>
    <v-switch v-model="data.actv" label="Activo"></v-switch>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
export default {
  name: "ZonasImpresionForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      data: {
        nomb: null,
        dpto: null,
        actv: true,
      },
      rules: {
        name: [(value) => !!value || "El nombre es obligatorio"],
        dpto: [(value) => !!value || "El departamento es obligatorio"],
      },
    };
  },
  computed: {
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;

      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.Id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {
      this.data.nomb = this.dataEdit.nomb;
      this.data.dpto = this.dataEdit.dpto;
    }
  },
};
</script>
